import styled, { keyframes } from 'styled-components';

// Styled components
const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  margin-top:40px;
  animation: ${fadeIn} 1s ease-in-out forwards; /* Apply the fade-in animation */

`;
export const FieldContainer=styled.div`
margin-top:20px;
width: 30%;
height: 72px;
flex-shrink: 0;
border-radius: 12px;
background: #FFF;
display:flex;
flex-direction:row;
text-align:center;
margin-right:35px ;
animation: ${fadeIn} 1s ease-in-out forwards; /* Apply the fade-in animation */
`;
export const AddressFieldContainer=styled.div`
margin-top:20px;

width: 95%;
height: 100px;
flex-shrink: 0;
border-radius: 12px;
background: #FFF;
display:flex;
flex-direction:row;
text-align:center;
margin-right:35px 

`;

export const Fields=styled.div` 
padding:10px; 
display:flex;
flex-wrap:wrap;
animation: ${fadeIn} 1s ease-in-out forwards; /* Apply the fade-in animation */

`;

export const FieldLabel=styled.div`
color: #000;
font-family: Product Sans;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: normal;
padding-top:25px;
padding-left:0px;
width:30%;
`
export const AddressFieldLabel=styled.div`
color: #000;
font-family: Product Sans;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: normal;
padding-top:25px;
padding-left:0px; 
width:9%;
`
export const Select = styled.select`
cursor:pointer;
margin: 14px;
padding: 10px;
border-radius: 30px;
border:none;
background: #EBEBEE;
width: 60%;
height: 44px;
flex-shrink: 0;
outline:none;
font-size:16px;
`;
export const AddressInput = styled.textarea`
cursor:pointer;
margin-top: 14px;
margin-left: 14px;
padding-top: 10px;
padding-bottom: 10px;
padding-left: 10px;
border-radius: 30px;
border:none;
background: #EBEBEE;
width: 87%;
height: 25px;
flex-shrink: 0;
outline:none;
font-size:16px;
height: 50px; 

`;
export const Input = styled.input`
cursor:pointer;
margin: 14px;
padding: 10px;
border-radius: 30px;
border:none;
background: #EBEBEE;
width: 55%;
height: 25px;
flex-shrink: 0;
outline:none;
font-size:16px;
`;
export const ButtonContainer=styled.div`
argin-top: 30px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center; /* Horizontally center the inner element */
  align-items: center; /* Vertically center the inner element */
  animation: ${fadeIn} 1s ease-in-out forwards; /* Apply the fade-in animation */

`
export const Button = styled.button`
margin-left:5px;
float:right;
border:none;
display: flex;
width: 232px;
height: 48px;
padding: 8px 20px;
justify-content: center;
align-items: center;
gap: 10px;
flex-shrink: 0;
border-radius: 12px;
background: #4285F4;
color: var(--light-theme-ffffff-100, #FFF);
text-align: center;
font-family: Product Sans;
font-size: 13px;
font-style: normal;
font-weight: 700;
line-height: 24px; /* 150% */
text-transform: uppercase;
cursor:pointer
`;

export const ProgressBar = styled.progress`
  height: 50px;
  margin-top: 10px;
  margin-left: 200px;
  width:60%;
  
`;
export const Option = styled.option`
cursor:pointer;
  background-color: #f2f2f2;
  color: #333;
  padding: 5px;
  font-size:16px
  outline: none; 
  line-height: 1.5; 
   
`;
const flashAnimation = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;


export const StatusLabel=styled.div`

font-family: Product Sans;
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: normal;
padding-top:25px;
padding-left:30px;
animation: ${flashAnimation} 1s infinite alternate;
`